import { z } from 'zod';

/**
 * this is a custom boolean schema that can be used to parse a boolean value from a string such as
 * - 'true' or true
 * - 'false' or false
 */
export const booleanSchema = z.custom<boolean>().transform((value, ctx) => {
  const textBool = `${value}`;
  if (textBool.toLowerCase() == 'true') return true;
  if (textBool.toLowerCase() == 'false') return false;

  ctx.addIssue({
    code: 'custom',
    message: 'validation_boolean_is_not_valid',
  });

  return false;
});
